<template lang="pug">
.k-booking-modal-reminder
  k-card-modal(
    :value="value"
    :max-width="600"
    closable
    persistent
    v-on="$listeners"
  )
    template(v-slot:header-outer)
      k-card-text.overflow-hidden
        .title--regular.brand-dark-blue--text.font-weight-bold.pr-5 Your booking with {{ bookingWithName }} {{ !isStarting && hasStarted ? 'was scheduled to start ' : 'is starting ' }}
          span.brand-pink--text {{ startsInTime }}
          | .

    p(v-if="minutesUntilBookingStart >= 5 && !hasStarted").paragraph.mb-10 Now is a good time to check your video and audio are working :)
    k-booking-card-confirmed(:booking="booking" hide-menu)

  audio(ref="joinSound")
    source(src="@@/resources/audio/enter-call.wav" type="audio/wav")
</template>

<script>
import { sync, get } from 'vuex-pathify'
import { UsesAuthenticatedUser } from '@/mixins'

export default {
  mixins: [ UsesAuthenticatedUser ],
  props: {
    value: {
      default: false,
      type: Boolean,
    },
  },
  data () {
    return {
      counterInterval: null,
      isStarting: false,
      startsInTime: '',
      hasStarted: false,
      minutesUntilBookingStart: 0
    }
  },
  computed: {
    ...get({
      booking: 'myKintell/awaitingBookingSession',
    }),
    // This is a hacky way to get around sync not using the getter and the model not being available
    // It's the same value as booking
    ...sync({
      awaitingBookingSession: 'myKintell/awaitingBookingSession',
    }),
    hasJoinedBooking () {
      return this.authenticatedUserIsAdvisorOfBooking ? this.booking.isAdvisorInSession : this.booking.isLearnerInSession
    },
    bookingWithName () {
      return this.authenticatedUserIsAdvisorOfBooking ? this.booking.learner.fullName : this.booking.advisor.fullName
    },
    authenticatedUserIsAdvisorOfBooking () {
      return this.booking.advisorId === this.authenticatedUser.id
    }
  },
  watch: {
    booking: {
      handler (val) {
        if (val) {
          this.syncBookingData()
          this.tickBookingTime()
        } else {
          clearInterval(this.counterInterval)
          this.$emit(false)
        }
      },
      immediate: true,
    },
    value (val) {
      if (!val) {
        clearInterval(this.counterInterval)
      }
    }
  },
  mounted () {
    // small timeout so it has a chance to show first
    setTimeout(() => {
      try {
        this.$refs.joinSound.play().catch()
      } catch (e) {}
    }, 500)
  },
  destroyed () {
    // reset the awaiting booking session on leave
    this.awaitingBookingSession = null
    clearInterval(this.counterInterval)
  },
  methods: {
    /**
     * Hacky function to get around the fact that the component is not re-rendering for the booking getters
     */
    syncBookingData () {
      this.isStarting = this.booking.isStarting
      this.startsInTime = this.booking.startsInHumanTime
      this.hasStarted = this.booking.hasStarted
      this.minutesUntilBookingStart = this.booking.minutesUntilBookingStart
    },
    tickBookingTime () {
      this.counterInterval = setInterval(() => {
        if (!this.booking || this.hasJoinedBooking) {
          clearInterval(this.counterInterval)
          return
        }
        this.syncBookingData()
        // tick every 30 seconds
      }, 30000)
    },
  },
}
</script>
